
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.727 1.5C2.05 1.5 1.5 2.05 1.5 2.727v40.546c0 .678.55 1.227 1.227 1.227h32.546c.678 0 1.227-.55 1.227-1.227V2.727c0-.678-.55-1.227-1.227-1.227H2.727z","stroke":"#43474F","stroke-width":"3","fill":"#FFF"}}),_c('rect',{attrs:{"fill":"#FECD87","x":"19","y":"13","width":"12","height":"3","rx":"1"}}),_c('path',{attrs:{"fill":"#43474F","d":"M27 2h9v9h-9z"}}),_c('path',{attrs:{"fill":"#86909E","d":"M27 3l8 8h-8z"}}),_c('circle',{attrs:{"stroke":"#FEA424","stroke-width":"3","cx":"11.5","cy":"12.5","r":"3"}}),_c('rect',{attrs:{"fill":"#FECD87","x":"8","y":"28","width":"22","height":"3","rx":"1"}}),_c('rect',{attrs:{"fill":"#FECD87","x":"8","y":"35","width":"11","height":"3","rx":"1"}}),_c('rect',{attrs:{"fill":"#FECD87","x":"8","y":"21","width":"12","height":"3","rx":"1"}}),_c('rect',{attrs:{"fill":"#FECD87","x":"23","y":"21","width":"5","height":"3","rx":"1"}})])])
          )
        }
      }
    